import { render, staticRenderFns } from "./ChangePriorityTask.vue?vue&type=template&id=39b3c4d1&scoped=true"
import script from "./ChangePriorityTask.vue?vue&type=script&lang=ts"
export * from "./ChangePriorityTask.vue?vue&type=script&lang=ts"
import style0 from "./ChangePriorityTask.vue?vue&type=style&index=0&id=39b3c4d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b3c4d1",
  null
  
)

export default component.exports